// Main
import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import i18n from './extesions/i18n'

// Libs
import PortalVue from 'portal-vue'

// Styles
import '@/styles/main.scss'
import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import SvgSprite from 'vue-svg-sprite'

// Ritm-UI
import '@/components/r-ui'
import loader from './extesions/loader'
import skeleton from './extesions/skeleton'
import badge from './extesions/badger'
import disabler from './extesions/disabler'
import Notification from '@/extesions/notification'
import Dialog from '@/extesions/dialog'

// Element
import './extesions/element'

// Date formatter
import RitmDate from 'ritm-date'

// Other
import { URL } from '@/config/constants'
import request from 'API'

// WS
import ws from '@/extesions/ws'

const mixin = {
  data() {
    return { ...request, URL }
  },
  methods: {
    $rDate(date) {
      return new RitmDate(date).setLocale('ru')
    }
  }
}

Vue.mixin(mixin)

Vue.directive('loading', loader)
Vue.directive('skeleton', skeleton)
Vue.directive('badge', badge)
Vue.directive('disabled', disabler)

Vue.use(ws)

Vue.use(Vuelidate)
Vue.use(PortalVue)

Vue.use(Notification)
Vue.use(Dialog)

Vue.use(SvgSprite, {
  url: '/sprite/symbol/main.svg',
  class: ''
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
